import React from "react"

import LoginTemplateOem from "Components/UI/Templates/Login/LoginOem"

const LoginOem = () => {
  return <LoginTemplateOem />
}

export default LoginOem
